import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'

dayjs.extend(customParseFormat)

const DATE_FORMAT = 'MM/DD/YYYY'

/** Formats a date as `MM/DD/YYYY`, or returns `null` if the input is null. */
export const formatDate = (dateString: Date | null): string | null => {
  if (!dateString) return null
  return dayjs(dateString).format('MM/DD/YYYY')
}

/**
 * Serializes a segment value to a `Label:value` string.
 * Booleans are converted to `"Yes"` / `"No"`; arrays are comma-joined.
 */
export const formatText = (
  value: null | boolean | string | string[],
  label: string,
): string => {
  if (typeof value === 'boolean') value = value ? 'Yes' : 'No'
  if (Array.isArray(value)) value = value.join(',')
  return `${label}:${value}`
}

/**
 * Parses a date string to a `Date`, or returns `null` if empty/invalid.
 * Tries strict `MM/DD/YYYY` parsing first; falls back to ISO / locale parsing
 * for legacy or alternative input formats.
 */
export const parseDate = (dateString: string): Date | null => {
  if (!dateString) return null
  const strict = dayjs(dateString, DATE_FORMAT, true)
  if (strict.isValid()) return strict.toDate()
  const fallback = dayjs(dateString)
  return fallback.isValid() ? fallback.toDate() : null
}

/**
 * Include/exclude encoder.
 * No caret  → plain includes list (backward-compatible, include mode).
 * `,^item`  → per-item exclude prefix (matches backend `ParseSpecificObjectMultiplesValues`).
 * Returns null if both lists are empty.
 */
export const formatIncExcSegment = (
  label: string,
  includes: string[],
  excludes: string[],
): string | null => {
  if (includes.length === 0 && excludes.length === 0) return null
  if (excludes.length === 0) return `${label}:${includes.join(',')}`
  const allValues = [...includes, ...excludes.map((e) => `^${e}`)]
  return `${label}:${allValues.join(',')}`
}
